import {
  type FC, memo, useCallback, useEffect,
} from 'react';
import { useDispatch } from 'react-redux';

import { IPageEnd } from 'app/store/nodes/card/interfaces';
import * as lastPageActions from 'app/store/nodes/lastPage/actions';
import Analytics from 'app/lib/Analytics/Analytics';

import styles from './PromoTSO.module.css';

interface IPromoTSO {
  data?: IPageEnd,
}

const PromoTSO: FC<IPromoTSO> = memo((props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(lastPageActions.showHoliday());
  }, [dispatch]);

  const handleNoThanks = useCallback(() => {
    Analytics.track().tappedSkipPromoTSO();
    dispatch(lastPageActions.shiftStep());
  }, [dispatch]);

  const handleYesPlease = useCallback(() => {
    dispatch(lastPageActions.promoYes());
  }, [dispatch]);

  return (
    <div className={styles.steps}>
      <div className={styles.header}>
        Learn More
        <br />
        About TSO!
      </div>
      <div className={styles.description}>
        This card featured music from Trans-Siberian Orchestra (TSO). Want to learn more about the&nbsp;band, their
        tour, and their music?
      </div>
      <div className={styles.buttons}>
        <button className={styles.noThanks} type="button" onClick={handleNoThanks}>
          <span>no thanks</span>
        </button>
        <button className={styles.yesPlease} type="button" onClick={handleYesPlease}>
          yes, please
        </button>
      </div>
      <div className={styles.rules}>
        By clicking &quot;yes, please&quot;, your email address or phone number will be shared with Trans-Siberian
        Orchestra management, and you authorize them to contact you directly. Message and data rates may apply.
      </div>
    </div>
  );
});

export default PromoTSO;
